import { compose, withProps } from 'recompose';
import { withTranslator } from '@wh/ui-translations';
import { TRANSLATION_CONTEXT } from '../componentConfig';

export var withMyAccountTranslate = compose(withTranslator, withProps(function (props) {
  return {
    translate: props.t(TRANSLATION_CONTEXT)
  };
}));